export enum ClaimTableState {
  EMPTY,
  CONNECT_WALLET,
  LOADING,
  KYC,
  RETRY,
  NO_VESTING,
}
